module.exports = __webpack_public_path__ + "img/file_import.539c1d51.png";